'use es6';

import { attachStatHelpersToWindow } from 'ContentEditorUI/debugging/selector-stat-helpers';
import { allSelectors as CEUISelectors } from 'ContentEditorUI/debugging/attach-selector-stats';
export const allSelectors = Object.assign({}, CEUISelectors);
const IPEUISelectorsContextRequire = require.context('../redux/selectors', true, /^.*.js$/);
IPEUISelectorsContextRequire.keys().forEach(selectorPath => {
  const exportedSelectors = IPEUISelectorsContextRequire(selectorPath);
  allSelectors[selectorPath] = exportedSelectors;
});
attachStatHelpersToWindow(allSelectors);